/*
login.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/login',['jquery', 'ui-bootstrap', 'modernizr', 'angular', 'ui-router', 'loginApi',
    './modules/login-navbar/login-navbar',
    './modules/login-form/login-form',
    './modules/login-footer/login-footer',
    './modules/forgot-password-popup/forgot-password-popup',
    './modules/sign-up/sign-up', 'existingUserCheckApi',
    'geXss', 'messages', 'redirectUsingPostService',
    'no-cache-ajax'
], function () {

    // Module Dependencies
    var dependencies = [
        // vendor
        'ui.bootstrap',
        'ui.router',
        // child modules
        'Services.LoginApi',
        'Login.Modules.LoginNavbar',
        'Login.Modules.LoginForm',
        'Login.Modules.LoginFooter',
        'Login.Modules.ForgotPasswordPopUp',
        'Login.Modules.SignUp',
        'Directives.GeXss',
        //'Services.SessionStorage',
        'Services.ExistingUserCheckApi',
        'Services.Messages',
        'Services.authenticationStoreService',
        'Services.redirectUsingPostService'
    ];

    // Module Creation
    var mod = angular.module('Login', dependencies);
    var renderPage = true;

    mod.controller('loginMainCtrl', ['$window', '$scope', 'messages', '$sce',
        function ($window, $scope, messages, $sce) {
            $scope.displayMessage = false;
            var onTransitioningToSSO = function (messageData) {
                $scope.messageType = 'transitioningToSSO';
                $scope.displayMessage = true;
                $scope.continue = messages.get('continue');
                $scope.transitioningToSSOMessage = $sce.trustAsHtml(messages.get('SSOInTransitAccessingC360Credentials').replace(/{{ORG_NAME}}/g, messageData.orgLegalName));
                $scope.hideWithTransitioningToSSOMsg = true;

                $scope.redirectToSSO = function () {
                    $window.location.href = '/' + messageData.orgSSOIdentifier + '/SSO';
                };
            };

            $scope.$on('displayMessage', function (e, messageData) {
                if (messageData.type === 'transitioningToSSO') {
                    onTransitioningToSSO(messageData);
                }
            });
        }
    ]);

    // Routing Config
    mod.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {

        var hideLoginPageIfAlreadyAuthenticated = function () {
            return {
                isAuthenticated: ['$q', function ($q) {
                    return renderPage ? true : $q.defer().promise;
                }]
            };
        };

        var encryptWithXor = function (text, key) {
            var result = [];
            for (var i = 0; i < text.length; i++) {
                result.push(String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length)));
            }
            return result.join('');
        };

        $.urlParams = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results == null) {
                return null;
            } else {
                return decodeURIComponent(results[1]) || 0;
            }
        };
        var redirectionUrlAfterLogin = $.urlParams('redirectUrl');
        if (redirectionUrlAfterLogin) {
            try {
                var decodedUrl = encryptWithXor(atob(redirectionUrlAfterLogin), window.location.host);
                if (decodedUrl.indexOf('http') === 0) {
                    console.log('Redirection URL is set to: ' + decodedUrl + ' (encrypted)');
                    sessionStorage.setItem("redirectUrl", decodedUrl);
                }
            } catch (error) {
                console.log('Could not decode redirect url', error);
                console.log('Redirection URL is set to: ' + redirectionUrlAfterLogin + ' (url encoded)');
                sessionStorage.setItem("redirectUrl", redirectionUrlAfterLogin);
            }
        }

        // For any unmatched url, redirect to '/inbox'
        $urlRouterProvider.otherwise('/');

        // Define the login app's states
        $stateProvider
            .state('app', {
                abstract: true,
                templateUrl: 'javascripts/login/templates/login.html'
            })
            .state('app.userRegistration', {
                url: '/userRegistration',
                views: {
                    'userRegistration': {
                        templateUrl: 'javascripts/registration/templates/user-registration.html',
                        controller: 'RegistrationCtrl'
                    }
                }
            })
            .state('app.login', {
                url: '/',
                views: {
                    'navbar': {
                        templateUrl: 'javascripts/login/modules/login-navbar/templates/login-navbar.html',
                        controller: 'LoginNavbarCtrl'
                    },
                    'login-form': {
                        templateUrl: 'javascripts/login/modules/login-form/templates/login-form.html',
                        controller: 'LoginFormCtrl'
                    },
                    'forgot-password-popup': {
                        templateUrl: 'javascripts/login/modules/forgot-password-popup/templates/forgot-password-popup.html',
                        controller: 'ForgotPasswordPopUpCtrl'
                    },
                    'sign-up': {
                        templateUrl: 'javascripts/login/modules/sign-up/templates/sign-up.html',
                        controller: 'SignUpCtrl'
                    },
                    'footer': {
                        templateUrl: 'javascripts/login/modules/login-footer/templates/login-footer.html',
                        controller: 'LoginFooterCtrl'
                    }
                },
                resolve: hideLoginPageIfAlreadyAuthenticated()
            });
    }]);

    /**
     * @description
     * Whenever a user attempts to access a specific page within the app, they do so using a
     * hash-based route. If the user is not logged in, however, rather than reaching the page
     * they have requested, they will be redirected to the login page. When this occurs, the
     * hash-based route is preserved, showing up in the browser's address bar. Given that it
     * is not the page requested by the user, we don't want the hash route to be displayed, so
     * we remove it and store it in localStorage. Then, once the user has logged in, we must
     * restore the hash route so that the user is taken to the page that they originally
     * requested. This run block performs the removal/storage step of this procedure.
     *
     *
     *
     */
    mod.run(['$rootScope', '$window', 'existingUserCheckApi', '$sce', 'loginApi', 'authenticationStoreService', 'redirectUsingPostService',
        function ($rootScope, $window, existingUserCheckApi, $sce, loginApi, authenticationStoreService, redirectUsingPostService) {

            if ($window.playInfoMessage) {
                authenticationStoreService.invalidate();
            }

            var isUserAuthenticated = authenticationStoreService.getCIdToken() && !localStorage.getItem('ideosanteinprogress');

            if (isUserAuthenticated) {
                var jsonData = {
                    refreshToken: localStorage.refreshToken,
                    cIdToken: authenticationStoreService.getCIdToken(),
                    idToken: localStorage.idToken
                };

                $.ajax({
                    async: false,
                    contentType: 'application/json',
                    type: 'post',
                    data: JSON.stringify(jsonData),
                    url: '/tokenValidate',
                    success: function () {
                        authenticationStoreService.restorePreAuthenticatedSession();
                        renderPage = false;
                        redirectUsingPostService.redirect('ib');
                    },
                    error: function () {
                        console.log("Error in token Validation");
                        authenticationStoreService.invalidate();
                    }
                });
            } else {
                authenticationStoreService.invalidate();
                localStorage.removeItem('ideosanteinprogress');
            }

            jQuery.ajaxSetup({
                cache: false
            });

            if (renderPage) {
                //clear specific session storage data's
                sessionStorage.removeItem('sessionData');
                sessionStorage.removeItem('externalAuthVerified');
            }

            $rootScope.bgImage = "getImage/default/ge-healthcare-bg.jpg";
            var orgLogoArray;

            angular.element('body').data('baseurl') + "/";

            $rootScope.bgImageOpacity = 1;
            var IMAGE_BASE_URL = "/getImage/";

            loginApi.getOrganizationNameFromSession().then(function (organisationName) {
                if (organisationName && organisationName !== '' && organisationName !== "login" && organisationName !== "logout" && organisationName !== "caseexchange") {
                    loginApi.getCustomizeLogoInfo(organisationName).then(function (response) {
                        if (organisationName && response && response.length > 0) {
                            orgLogoArray = response[0];

                            sessionStorage.setItem("orgUrl", organisationName);

                            $rootScope.orgLogoObj = orgLogoArray;
                            $rootScope.bgImage = orgLogoArray.loginScreenImage ? IMAGE_BASE_URL + orgLogoArray.uuid + "/" + orgLogoArray.loginScreenImage : $rootScope.bgImage;
                            $rootScope.bgImageOpacity = orgLogoArray.loginScreenImage ? orgLogoArray.opacity / 100 : $rootScope.bgImageOpacity;
                        } else {
                            $window.location.href = "/notFound";
                        }
                    });
                }
            });

            // If url has a hash, it's because the user tried to access a page that uses hash routing and
            // was redirected to the login page instead. In order to redirect them to the page they were
            // trying to go to, we save the hash route now and restore it once the user is logged in.
            if ($window.location.hash) {

                var sessionUrl = sessionStorage.getItem('orgUrl');
                authenticationStoreService.clearSessionStorageExceptAuthKeys();

                // store the hash so we can restore it once the user is logged in
                sessionStorage.hashToRestore = $window.location.hash;
                // remove the hash from the URL (if we can do so without reloading the page)
                if ("pushState" in history) {
                    if (sessionUrl) {
                        history.pushState('', document.title, '/' + sessionUrl);
                    } else {
                        history.pushState('', document.title, '/');
                    }

                }
            }
        }
    ]);

    // Bootstrap the application
    angular.bootstrap(document, ['Login']);

});

define('login', ['login/login'], function (main) { return main; });

